import classNames from '@sindresorhus/class-names';
import {BaseHeaderButton} from '@ui-kit/src/Header';

import {AuthHeaderComponent} from '@web-catalog/components/Auth/AuthHeaderComponent';

import {AuthProgressState, useAuthProgressState} from '@web-catalog/store/auth';

import {useLayoutAnalytics} from '../useLayoutAnalytics';
import {HeaderSearch} from './HeaderSearch';
import styles from './RightSideContent.module.scss';

type Props = {
  hideSearchButton?: boolean;
};

const authStatesForShow: Array<AuthProgressState> = ['notify_user', 'finished'];

export const RightSideContent = ({hideSearchButton}: Props) => {
  const {logDownloadRustoreTopClick} = useLayoutAnalytics();
  const authProgressState = useAuthProgressState();
  const shouldShowAvatar = authStatesForShow.includes(authProgressState);
  return (
    <>
      <div
        className={classNames(
          styles.wrapper,
          shouldShowAvatar && styles.withAvatarAnimation,
        )}
      >
        {!hideSearchButton && <HeaderSearch />}
        <BaseHeaderButton
          hoverVariant="blue"
          withTextPaddings
          highlightOnTopScroll
          href="https://www.rustore.ru/instruction"
          onClick={logDownloadRustoreTopClick}
          data-testid="goToDownloadInstruction"
        >
          Скачать<span className={styles.hideRustorePart}>&nbsp;RuStore</span>
        </BaseHeaderButton>
        {shouldShowAvatar && <AuthHeaderComponent size={36} />}
      </div>
    </>
  );
};
